module.exports = __webpack_public_path__ + "img/Ciberseguridad-011124.bc17d6f1.jpg";